import { api } from '../../core/network/api';

/** Job period — matches the backend QuestType (we only surface DAILY/WEEKLY). */
export type JobType = 'DAILY' | 'WEEKLY' | 'MILESTONE' | 'SEASONAL';

/** Status as returned by the core QuestService (ACTIVE jobs are still in progress). */
export type JobStatus = 'ACTIVE' | 'COMPLETED';

export interface JobReward {
  cash: number; // SOFT
  goldBars: number; // PREMIUM
  xp: number;
}

/** A player's active job (a UserQuest joined with its Quest definition). */
export interface Job {
  id: string; // userQuest id — used for claim
  slug: string;
  name: string;
  description: string;
  type: JobType;
  action: string;
  progress: number;
  target: number;
  status: JobStatus;
  claimable: boolean;
  reward: JobReward;
}

export interface JobsView {
  jobs: Job[];
}

export interface JobClaimResult {
  claimed: boolean;
  reward: { soft: number; premium: number; xp: number };
}

/** GET /api/jobs — the player's active daily + weekly jobs (lazily assigned). */
export const fetchJobs = () => api.get<JobsView>('/jobs');

/** POST /api/jobs/:id/claim — claim a completed job's reward. */
export const claimJob = (id: string) =>
  api.post<JobClaimResult>(`/jobs/${id}/claim`);
